import { useMutation } from '@tanstack/react-query';
import { api } from 'src/services';

export type DownloadCSVPayload = {
  s3_key: string;
  bucket_name?: string;
};

export type DownloadCSVResponse = {
  download_url: string;
};

export const useDownloadAppointmentCSV = () => {
  return useMutation({
    mutationKey: ['downloadAppointmentCSV'],
    mutationFn: (payload: DownloadCSVPayload) =>
      api
        .post<DownloadCSVResponse>('/download_csv', payload)
        .then((res) => res.data),
  });
};
